// import { Pie, Bar } from "chart.js";
// import { Chart as ChartJS, ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend, Pie, Bar } from "chart.js";
// ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend);
import { Chart } from 'primereact/chart';


export default function Charts({ data }) {
  const options = {
  maintainAspectRatio: false,
  responsive: true,
  // other options...
};
  const turnoutPie = {
    labels: ["Total Ballots Cast", "Did Not Vote"],
    datasets: [
      {
        data: [data?.totalVotes||0, data?.registeredVoters||0 - data?.totalVotes||0],
        backgroundColor: ["#3b82f6", "#d1d5db"],
      },
    ],
  };

  const ballotsPie = {
    labels: ["Valid Ballots", "Spoiled Ballots"],
    datasets: [
      {
        data: [data?.validVotes||0, data?.spoiledVotes||0],
        backgroundColor: ["#10b981", "#ef4444"],
      },
    ],
  };

  const votesBar = {
    labels: ["Total", "Valid", "Rejected", "Spoiled", "Contested", "Special"],
    datasets: [
      {
        label: "Votes",
        data: [
          data?.totalVotes,
          data?.validVotes,
          data?.rejectedVotes,
          data?.spoiledVotes,
          data?.contestedVotes,
          data?.specialVotes,
        ],
        backgroundColor: ["#3b82f6", "#10b981", "#ef4444", "#f59e0b", "#8b5cf6", "#d1d5db"],
      },
    ],
  };

  const candidateBar = {
    labels: data?.candidateResults.map((c) => c.candidateName),
    datasets: [
      {
        label: "Percentage of Votes",
        data: data?.candidateResults.map((c) => c.percentage),
        backgroundColor: "#3b82f6",
      },
    ],
  };

  return (
    <section className="mb-12">
      <div className="grid graphs ">
        <div className="col-12 md:col-6 lg:col-4">
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Voter Turnout <span>{((data?.totalVotes||0 / data?.registeredVoters||0) * 100).toFixed(1)}%</span> </h3>
            <Chart type='pie' data={turnoutPie} />
          </div>
        </div>

        <div className="col-12 md:col-6 lg:col-4">
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Ballots Cast Distribution</h3>
            <Chart type='pie' data={ballotsPie} />
          </div>
        </div>
        <div className="col-12 md:col-6 lg:col-4">
          <div className="bg-white p-6 rounded-lg shadow col-span-2">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Votes</h3>
            <Chart type='bar'  options={options} data={votesBar} />
          </div>
        </div>
        <div className="col-12 md:col-6 lg:col-12">
          <div className="bg-white p-6 rounded-lg shadow col-span-2">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Candidate Votes</h3>
            <Chart type='bar'  data={candidateBar} options={{ indexAxis: "y",...options }} />
          </div>
        </div>





      </div>
    </section>
  );
}
